<template>
  <div class="page-code-add-info">
    <el-form ref="form" :rules="rules" :model="form" label-width="110px" class="form-box">
      <el-form-item
        label="代码位名称"
        prop="adslot_name"
      >
        <el-input v-model="form.adslot_name" show-word-limit :maxlength="30" clearable />
      </el-form-item>
      <el-form-item
        label="所属应用"
        prop="media_id"
      >
        <el-select
          v-model="form.media_id"
          placeholder="请选择"
          clearable
          filterable
          :disabled="!!id"
        >
          <el-option
            v-for="item in appOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渲染方式" prop="render_method">
        <el-radio-group v-model="form.render_method">
          <el-radio-button
            v-for="item in renderMethodOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="创意类型" prop="acc_adtype">
        <el-radio-group v-model="form.acc_adtype">
          <el-radio-button
            v-for="item in accAdtypesOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="屏幕方向" prop="screen_ori">
        <el-radio-group v-model="form.screen_ori">
          <el-radio-button
            v-for="item in screenOriOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="跳过按钮" prop="insert_screen_skip_button">
        <span class="btn-input-box">
          <el-radio-group
            value=""
            @change="handleSkipChange"
          >
            <el-radio-button
              v-for="item in skipShowOptions"
              :key="item.value"
              :label="item.value"
            >{{item.label}}</el-radio-button>
            <el-radio-button
              :label="-1"
            >
            <span style="display: inline-block;width: 80px;"></span>
            </el-radio-button>
          </el-radio-group>
          <span class="btn-input-span">
            <el-input v-model="form.insert_screen_skip_button" class="btn-input" />
            <span class="unit-text">秒</span>
          </span>
        </span>
      </el-form-item>
      <!--
      <el-form-item
        label="奖励名称"
        prop="award_name"
      >
        <el-input v-model="form.award_name" show-word-limit :maxlength="30" />
      </el-form-item>
      <el-form-item
        label="奖励数量"
        prop="award_qua"
      >
        <el-input v-model="form.award_qua" />
      </el-form-item>
      <el-form-item label="奖励发放设置" prop="reward_opt">
        <el-radio-group v-model="form.reward_opt">
          <el-radio-button
            v-for="item in rewardOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      -->
      <el-form-item label="竞价类型" prop="bidding_type">
        <el-radio-group
          v-model="form.bidding_type"
          :disabled="!!id"
          @change="handleBiddingTypeChange"
        >
          <el-radio-button
            v-for="item in biddingTypeOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="+form.bidding_type === 2"
        prop="bid_cpm"
        label="CPM价格"
      >
        <el-input 
          v-model="form.bid_cpm"
          :disabled="!!id">
          <span class="unit-text" slot="suffix">元</span>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCodeDetail, getAllAppList, doAddCode, doEditCode } from '@/apis/flow.js';
import { RenderMethodModule, AccAdtypesVideo, ScreenOri, BiddingTypes, BiddingTypes2, SkipOptions, RewardOptions } from '@/common/constant'

export default {
  props: {
    codeType: {
      default: ''
    },
  },
  data () {
    return {
      appOptionsMap: {},
      appOptions: [],
      renderMethodOptions: [
        ...RenderMethodModule
      ],
      accAdtypesOptions: [
        ...AccAdtypesVideo
      ],
      biddingTypeOptions: [],
      screenOriOptions: [
        ...ScreenOri
      ],
      skipShowOptions: [
        ...SkipOptions
      ],
      rewardOptions: [
        ...RewardOptions
      ],
      rules: {
        adslot_name: [
          { required: true, message: '代码位名称必填' }
        ],
        media_id: [
          { required: true, message: '所属应用必选' }
        ],
        render_method: [
          { required: true, message: '渲染方式必选' }
        ],
        acc_adtype: [
          { required: true, message: '创意类型必选' }
        ],
        screen_ori: [
          { required: true, message: '视频播放方向必选' }
        ],
        bidding_type: [
          { required: true, message: '竞价类型必选' }
        ],
        // award_name: [
        //   { required: true, message: '奖励名称必填' }
        // ],
        // award_qua: [
        //   { required: true, message: '奖励数量必填' },
        //   {
        //     validator(rule,value,callback){
        //       if(Number.isInteger(Number(value)) && Number(value) > 0){
        //         callback();
        //       }else{
        //         callback(new Error("请输入有效数字"));
        //       }
        //     },
        //     message: '请填写整数'
        //   },
        // ],
        // reward_opt: [
        //   { required: true, message: '奖励发放设置必选' }
        // ],
        // motivate_video_skip_num: [
        //   {
        //     required: true,
        //     validator(rule,value,callback){
        //       callback();    
        //     },
        //   }
        // ],
        insert_screen_skip_button: [
          { required: true, message: '跳过秒数必填' },
          {
            validator(rule,value,callback){               
              if(Number.isInteger(Number(value))){                
                callback();
              }else{                 
                callback(new Error("请输入有效数字"));               
              }             
            },
            message: '请填写整数'
          },
        ],
        bid_cpm: [
          { required: true, message: 'CPM价格必填' },
          {
            validator(rule,value,callback){   
              const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/           
              if(reg.test(value) && Number(value) > 0){                
                callback();
              }else{                 
                callback(new Error("请输入有效数字"));               
              }             
            },
            message: '仅支持2位小数'
          },
        ]
      },
      form: {
        media_id: '',
        render_method: RenderMethodModule[0].value,
        acc_adtype: AccAdtypesVideo[0].value,
        screen_ori: ScreenOri[0].value,
        // motivate_video_skip_num: SkipOptions[0].value,
        insert_screen_skip_button: 5,
        bidding_type: BiddingTypes[0].value,
        // reward_opt: RewardOptions[0].value,
      }
    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    appName () {
      return this.$route.query.appName || ''
    },
  },
  created() {
    this.userInfo = this.$ls.get('userInfo');
    this.biddingTypeOptions = this.userInfo.auth.server_bid_auth ? BiddingTypes2 : BiddingTypes;
  },
  mounted() {
    this.getAllAppList()
    if (this.id) {
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      const { data = {} } = await getCodeDetail({
        id: this.id
      })
      this.form = {
        ...this.form,
        ...data,
      }
    },
    async getAllAppList() {
      const { data = [] } = await getAllAppList()
      this.appOptions = data
      if (!this.id && !this.form.media_id && data.length === 1) {
        this.form.media_id = data[0].id
      }
      data.forEach(item => {
        this.appOptionsMap[item.id] = item.name
        if (!this.id && item.name === this.appName) {
          this.form.media_id = item.id
        }
      })
    },
    handleSkipChange() {
      if (!this.form.insert_screen_skip_button) {
        this.$set(this.form, 'insert_screen_skip_button', 5)
      } else {
        this.$delete(this.form, 'insert_screen_skip_button')
      }
    },
    handleBiddingTypeChange() {
      this.$delete(this.form, 'bid_cpm')
    },
    onCancel() {
      this.$router.go(-1);
    },
    async onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.id) {
            const { message = '编辑成功' } = await doEditCode({
              ...this.form,
              id: this.id,
              type: this.codeType
            })
            this.$message.success(message)
          } else {
            const { message = '创建成功' } = await doAddCode({
              ...this.form,
              type: this.codeType
            })
            this.$message.success(message)
          }
          this.$router.go(-1);
        } else {
          return false;
        }
      });
    }
  }
}
</script>
